import { WorkflowSettingsPanel } from "./settings/WorkflowSettingsPanel";
import { WorkflowExecutionSettingsPanel } from "./settings/WorkflowExecutionSettingsPanel";

export const WorkflowSettings = () => {
    return (
        <div className="workflow-settings">
            <WorkflowSettingsPanel />
            <WorkflowExecutionSettingsPanel />
        </div>
    );
}